import React from 'react'
import { PropTypes } from 'prop-types'

class ActionLogic extends React.Component {
    mounted = false
    asyncSetState = (...args) => {
        // avoid setting state after unmount in case async operations attempts to do so
        if (this.mounted) this.setState(...args)
    }

    constructor (props) {
        super(props)

        this.state = {
            loading: false,
            error: false,
            data: null,
            ...(props.initState || {}),
        }
    }

    componentDidMount () {
        this.mounted = true

        const { onMount } = this.props

        onMount && onMount(this.getRenderProps())
    }

    componentWillUnmount () {
        this.mounted = false
    }

    clearErrors = () => {
        this.setState({
            error: false,
        })
    }

    callMutation = (mutation, options) => {
        this.asyncSetState({
            loading: true,
            error: false,
            data: null,
        })

        return mutation(options).then(response => {
            this.asyncSetState({
                loading: false,
                data: response && response.data ? response.data : null,
            })
            return Promise.resolve(response)
        })
            .catch(error => {
                this.asyncSetState({
                    loading: false,
                    error: error,
                })
                return Promise.reject(error)
            })
    }

    actions = {
        asyncSetState: this.asyncSetState,
        clearErrors: this.clearErrors,
        callMutation: this.callMutation,
    }

    getRenderProps () {
        return {
            ...this.state,
            ...this.actions,
        }
    }

    render () {
        return this.props.children(this.getRenderProps())
    }
}

ActionLogic.propTypes = {
    children: PropTypes.func.isRequired,
    initState: PropTypes.object,
    onMount: PropTypes.func,
    onComponentDidUpdate: PropTypes.func,
}

ActionLogic.defaultProps = {
    initState: {},
}

export default ActionLogic
